import baseTheme from './base-theme';
import lightTheme from './light-theme';
import darkTheme from './dark-theme';
import {
  debuggerDarkTheme,
  debuggerLightTheme,
} from './debugger-theme';

export { lightTheme, darkTheme };
export {
  debuggerDarkTheme,
  debuggerLightTheme,
};
export default baseTheme;
